import s from './delete-tree-structure-modal.module.css';
import { Button } from '../../../../../../../components/button/button';
import { ModalProps, Modal } from '../../../../../../../components/modal/modal';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useTreeStore } from '../../../../../../../store/use-tree-store';
import { TreeNodeType } from '../../../../../../../store/api/trees-api';
import { useSearchParams } from 'react-router-dom';

const deleteNode = (
  nodes: Partial<TreeNodeType>[],
  nodeId?: number | string,
): Partial<TreeNodeType>[] => {
  return nodes
    .filter((n) => String(n.id) !== String(nodeId))
    .map((n) => ({
      ...n,
      children: n.children ? deleteNode(n.children, nodeId) : [],
    }));
};

export const DeleteTreeStructureModal = (props: ModalProps) => {
  const { t } = useLang();
  const { handleUpdateTree, tree, isLoading } = useTreeStore();
  const [params] = useSearchParams();
  const id = params.get('deleteId') || '';
  const name = params.get('name');

  const handleDelete = () => {
    const updatedNodes = deleteNode(tree?.nodes || [], id);
    const updatedTree = { ...tree, nodes: updatedNodes };
    handleUpdateTree(updatedTree);
    props.onClose();
  };

  return (
    <Modal {...props} title={t('Удалить элемент')} className={s.feature}>
      <label>{t('Вы действительно хотите удалить элемент {{name}}?', { name })}</label>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Отменить')}
        </Button>
        <Button onClick={handleDelete} disabled={isLoading} variant="danger">
          {t('Удалить')}
        </Button>
      </div>
    </Modal>
  );
};
